import { Tabs, TabsProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFinancialStatementsState } from '../../../../../features/financialStatements'
import BalanceSheetTable from '../../../../../features/financialStatements/components/StatementTable/BalanceSheetTable'
import { CompanyDashboardItem } from '../../../../../types/dashboard/company/types'
import { Loading } from '../../../../../components/Misc/Loading'
import { ModalProvider } from '../../../../../features/financialStatements/components/StatementTable/ModalContext'
import { DriverDataProvider } from '../../../../../features/driverData/context/DriverDataContext'
import { DeprecationPlanProvider } from '../../../../../features/deprecationPlan/context/DeprecationPlanContext'

interface BalanceSheetProps {
  // item: CompanyDashboardItem
  // width: number
  height: number
}

export const BalanceSheet: React.FC<BalanceSheetProps> = ({ height }: BalanceSheetProps) => {
  const { t } = useTranslation()
  const { companyId, statementData, columns, statementLoading, statementFetching, financialStatementsFilters } =
    useFinancialStatementsState(false) // false = not budgeting page

  const isLoading = statementLoading || statementFetching

  if (isLoading) return <Loading />
  if (!companyId) return <div>No company selected</div>

  const tabItems: TabsProps['items'] = [
    {
      label: t('financialStatementsPage:assets'),
      key: 'assets',
      destroyInactiveTabPane: true,
      children: (
        <div style={{ height, display: 'flex', flexDirection: 'column' }}>
          <BalanceSheetTable
            treeData={statementData?.assets ?? []}
            columns={columns}
            loading={isLoading}
            statementType="assets"
            companyId={companyId}
            financialStatementsFilters={financialStatementsFilters}
            hideControls
          />
        </div>
      )
    },
    {
      label: t('financialStatementsPage:liabilities'),
      key: 'liabilities',
      destroyInactiveTabPane: true,
      children: (
        <div style={{ height, display: 'flex', flexDirection: 'column' }}>
          <BalanceSheetTable
            treeData={statementData?.liabilities ?? []}
            columns={columns}
            loading={isLoading}
            statementType="liabilities"
            companyId={companyId}
            financialStatementsFilters={financialStatementsFilters}
            hideControls
          />
        </div>
      )
    }
  ]

  const filteredTabItems = tabItems.filter(item => {
    if (item.key === 'assets' && (!statementData?.assets || statementData.assets.length === 0)) return false
    if (item.key === 'liabilities' && (!statementData?.liabilities || statementData.liabilities.length === 0))
      return false
    return true
  })

  return (
    <ModalProvider>
      <DriverDataProvider>
        <DeprecationPlanProvider>
          <Tabs items={filteredTabItems} defaultActiveKey="assets" />
        </DeprecationPlanProvider>
      </DriverDataProvider>
    </ModalProvider>
  )
}
